module.exports = __webpack_public_path__ + "static/media/icon-load.39410562.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/icon-load.png
// module id = 1951
// module chunks = 6